<!-- エリア1: 検索コントロール -->
<div class="search-section">
  <div class="search-row">
    <label for="jobOrderId">獲注番号</label>
    <input 
      type="text" 
      id="jobOrderId" 
      [(ngModel)]="jobOrderId"
      maxlength="9"
      pattern="[0-9]*"
      (keypress)="onNumberKeyPress($event)"
      placeholder="9桁の数字を入力"
      autocomplete="off"
    />
    <button class="btn-display" (click)="loadJobOrderInfo()">表示</button>
    <button class="btn-clear" (click)="onClear()">クリア</button>
    <button class="btn-download btn-green" (click)="downloadLedger()" [disabled]="!jobOrderData?.basic">台帳Excel</button>
    <button class="btn-download btn-green" (click)="downloadPdf()" [disabled]="!jobOrderData?.basic">台帳PDF</button>
    <button *ngIf="readWrite && adminLevel >= 2" class="btn-change-request btn-red" (click)="onChangeRequestClick()" [disabled]="!jobOrderData?.basic || !isRequestButtonEnabled">削除/変更申請</button>
  </div>
  <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
</div>

<!-- データ表示エリア -->
<div *ngIf="jobOrderData && jobOrderData.basic" class="data-container">

  <!-- エリア3と申請ブロックを横並びに -->
  <div class="overview-and-request-section">
    <!-- エリア3: 詳細情報 -->
    <div class="details-section">
    <table class="unified-info-table">
      <!-- スタッフ情報 -->
      <thead>
        <tr>
          <th colspan="8" class="section-title">スタッフ情報</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>契約期間</th>
          <td colspan="3">{{ jobOrderData.basic?.orderDate }}</td>
          <th>スタッフ番号</th>
          <td><a (click)="onAscClick(jobOrderData.basic?.userCode!)" class="link-text">{{ jobOrderData.basic?.userCode }}</a></td>
          <th>スタッフ氏名</th>
          <td>{{ jobOrderData.basic?.userName }}</td>
        </tr>
        <tr>
          <th>業務内容</th>
          <td colspan="7" class="job-title-col">{{ jobOrderData.basic?.jobTitle }}</td>
        </tr>
        <tr>
          <th>責任程度</th>
          <td colspan="7" class="job-title-col">{{ jobOrderData.basic?.jobResponsibility }}</td>
        </tr>
      </tbody>

      <!-- 企業情報 -->
      <thead>
        <tr>
          <th colspan="8" class="section-title">企業情報（派遣先・委託者・就業部門等）</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>顧客番号</th>
          <td>{{ jobOrderData.basic?.customerCode }}</td>
          <th>顧客名</th>
          <td colspan="2">{{ jobOrderData.basic?.customerName }}</td>
          <th>責任者</th>
          <td colspan="2">{{ jobOrderData.basic?.customerChairman }}</td>
        </tr>
        <tr>
          <th>部署番号</th>
          <td><a (click)="onCustomerOfficeClick(jobOrderData.basic?.customerOfficeId!)" class="link-text">{{ jobOrderData.basic?.customerOfficeCode }}</a></td>
          <th>部署名</th>
          <td colspan="2">{{ jobOrderData.basic?.customerOfficeName }}</td>
          <th>指揮命令者</th>
          <td colspan="2">{{ jobOrderData.basic?.customerPerson }}</td>
        </tr>
        <tr>
          <th>組織単位</th>
          <td colspan="4">{{ jobOrderData.basic?.jobOrgUnitName }}</td>
          <th>苦情受付者</th>
          <td colspan="2">{{ jobOrderData.basic?.customerComplaint }}</td>
        </tr>
        <tr>
          <th>就業場所</th>
          <td colspan="7">{{ jobOrderData.basic?.officeAddress }}</td>
        </tr>
      </tbody>

      <!-- 事業主情報 -->
      <thead>
        <tr>
          <th colspan="8" class="section-title">事業主情報（派遣元・受託者・採用部門等）</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>会社名</th>
          <td colspan="2">マンパワーグループ株式会社</td>
          <th>支店名</th>
          <td colspan="2">{{ jobOrderData.basic?.brcName }}</td>
          <th>責任者</th>
          <td>{{ jobOrderData.basic?.mpChairman }}</td>
        </tr>
        <tr>
          <th>住所</th>
          <td colspan="5">{{ jobOrderData.basic?.brcAddress }}</td>
          <th>苦情受付者</th>
          <td>{{ jobOrderData.basic?.mpComplaint }}</td>
        </tr>
      </tbody>
    </table>
  </div>

    <!-- 申請ブロック -->
    <div *ngIf="showRequestBlock" class="request-block-section">
      <h3>削除/変更申請</h3>
      
      <!-- 申請履歴ブロック -->
      <div class="request-history-block">
        <ng-container *ngIf="changeRequestHistories.length === 0">
          <div class="info-text"><span class="bld">タイムシートの期間を短縮したい場合は、POWER Base上で獲注の終了日の変更を行ってください。</span><br />
          翌日のバッチでDirectTimeに反映されますので、<span class="bld">こちらの申請フォームから申請いただく必要はありません。</span></div>
          <div class="info-text">以下の場合のみ、削除/変更種類を選択して申請してください。</div>
          <ul class="info-text">
          <li>獲注のキャンセルなどにより、獲注ごと削除する必要がある場合 ➡<span class="bld">「獲注削除」</span>を選択</li>
          <li>POWER Baseで期間短縮ができない場合（DirectTimeの使用開始前など）➡<span class="bld">「獲注削除」</span>を選択</li>
          <li>他社のタイムシートに移るなど、獲注の稼働期間はそのままでタイムシートの期間のみ短縮したい場合➡<span class="bld">「期間短縮」</span>を選択</li>
          </ul>
        </ng-container>
        <h4 *ngIf="changeRequestHistories.length > 0">申請履歴</h4>
        <ul class="history-list">
          <li *ngFor="let history of changeRequestHistories">
            <div class="history-item">
              {{ history.request }}
              <div *ngIf="history.procComment" class="proc-comment">
                 [サポート担当コメント] {{ history.procComment }}
              </div>
            </div>
          </li>
        </ul>
        <button *ngIf="showCancelButton" class="btn-cancel-request" (click)="cancelChangeRequest()">
          申請を取り消す
        </button>
      </div>

      <!-- 申請フォームブロック -->
      <div *ngIf="showRequestForm" class="request-form-block">
        <div class="form-container">
          <div class="form-fields">
            <div class="form-row-top">
              <div class="form-field">
                <label>削除/変更種類</label>
                <select [(ngModel)]="selectedChangeType" (change)="onChangeTypeChange()" class="form-select">
                  <option [ngValue]="null" disabled>-- 選択してください --</option>
                  <option *ngFor="let type of changeRequestTypes" [ngValue]="type.typeId">
                    {{ type.itemName }}
                  </option>
                </select>
              </div>
              
              <div class="form-field">
                <label>理由</label>
                <input type="text" [(ngModel)]="requestComment" class="form-input comment-input" />
              </div>
            </div>
            
            <div class="form-row-bottom">
              <div class="form-field">
                <label>TS削除開始日*</label>
                <input 
                  type="text" 
                  [(ngModel)]="tsDeleteStartDate"
                  (input)="formatDateInput($event)"
                  [readonly]="isTsDeleteStartDateLocked()"
                  [disabled]="isTsDeleteStartDateLocked()"
                  placeholder="yyyy/MM/dd"
                  maxlength="10"
                  class="form-input date-input"
                />
              </div>
              
              <div class="form-field">
                <label>上長メールアドレス</label>
                <input 
                  type="email" 
                  [(ngModel)]="mngEmail" 
                  class="form-input email-input"
                  placeholder="example@manpowergroup.jp"
                />
              </div>
            </div>
            <div class="info-text">*タイムシートがこの日から不要となる日を指定してください。</div>
          </div>
          
          <div class="form-submit-area">
            <button class="btn-submit-request" (click)="submitChangeRequest()">申請する</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- エリア4: タイムシート情報 -->
  <div class="timesheets-section">
    <h3>この獲注に紐づくタイムシート</h3>
    <div class="table-wrapper">
      <table class="timesheets-table">
        <thead>
          <tr>
            <th>年月度</th>
            <th class="col-timesheet-id">タイムシートID</th>
            <th class="col-timesheet-no">TS番号</th>
            <th>締日</th>
            <th>時間内</th>
            <th>時間外</th>
            <th>深夜</th>
            <th>合計</th>
            <th>未報告</th>
            <th>報告済</th>
            <th>否認</th>
            <th>承認済</th>
            <th>出勤</th>
            <th>欠勤</th>
            <th>有休</th>
            <th>在宅</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ts of jobOrderData.timesheets">
            <td>{{ ts.yearMonth }}</td>
            <td>
              <a (click)="onTimesheetClick(ts)" class="link-text">
                {{ ts.timesheetId }}
              </a>
            </td>
            <td class="text-right">{{ ts.timesheetNo }}</td>
            <td class="text-center">{{ formatCloseDate(ts.closeDate) }}</td>
            <td class="text-right">{{ ts.workTime }}</td>
            <td class="text-right">{{ ts.overWorkTime }}</td>
            <td class="text-right">{{ ts.midnightWorkTime }}</td>
            <td class="text-right">{{ ts.total }}</td>
            <td class="text-center">{{ ts.editing }}</td>
            <td class="text-center">{{ ts.submitted }}</td>
            <td class="text-center">{{ ts.denied }}</td>
            <td class="text-center">{{ ts.approved }}</td>
            <td class="text-center">{{ ts.attendanceDays }}</td>
            <td class="text-center">{{ ts.absence }}</td>
            <td class="text-center">{{ ts.paidHoliday }}</td>
            <td class="text-center">{{ ts.teleWork }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="jobOrderData.timesheets.length === 0" class="no-data">
      タイムシートデータがありません
    </div>
  </div>

  <!-- エリア5: 承認者情報 -->
  <div class="approvers-section">
    <h3>この獲注に紐づく承認者</h3>
    <div class="table-wrapper">
      <table class="approvers-table">
        <thead>
          <tr>
            <th>UserID</th>
            <th>承認者氏名</th>
            <th>LoginID</th>
            <th>登録メールアドレス</th>
            <th>PR</th>
            <th>修正</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let approver of jobOrderData.approvers">
            <td>{{ approver.userId }}</td>
            <td>{{ approver.userName }}</td>
            <td>{{ approver.loginId }}</td>
            <td>
              <input 
                type="email" 
                [(ngModel)]="approver.email2" 
                class="email-input"
                placeholder="メールアドレスを入力"
              />
            </td>
            <td class="checkbox-cell">
              <input type="checkbox" [checked]="approver.passwordReset" disabled />
            </td>
            <td>
              <button 
                class="action-button" 
                [disabled]="!readWrite || adminLevel < 2 || !isEmailChanged(approver)"
                (click)="saveApproverEmail(approver)">
                修正
              </button>
              <button 
                class="action-button reset-button" 
                (click)="resetEmail(approver.userId)"
                [disabled]="!readWrite || adminLevel < 2">
                メルアドリセット
              </button>
              <button 
                class="action-button password-reset-button" 
                (click)="sendPasswordReminder(approver.userId)"
                [disabled]="!readWrite || adminLevel < 2">
                パスワードリセット
              </button>
            </td>
          </tr>
          <tr *ngIf="jobOrderData.approvers.length === 0">
            <td colspan="6" class="no-data">承認者データがありません</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- エリア6: MP担当者情報 -->
  <div class="approvers-section">
    <h3>この獲注に紐づくMP担当者</h3>
    <div class="table-wrapper">
      <table class="approvers-table">
        <thead>
          <tr>
            <th>UserID</th>
            <th>担当者氏名</th>
            <th>メールアドレス</th>
            <th>承認</th>
            <th>担当</th>
            <th>Level</th>
            <th>R/W</th>
            <th>有効</th>
            <th>所属</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let rep of reps">
            <td>{{ rep.userId }}</td>
            <td>{{ rep.userName }}</td>
            <td>{{ rep.email }}</td>
            <td class="checkbox-cell"><input type="checkbox" [checked]="rep.approver" disabled /></td>
            <td class="checkbox-cell"><input type="checkbox" [checked]="rep.manager" disabled /></td>
            <td>{{ rep.adminLevel }}</td>
            <td class="checkbox-cell"><input type="checkbox" [checked]="rep.readWrite" disabled /></td>
            <td class="checkbox-cell"><input type="checkbox" [checked]="rep.enabled" disabled /></td>
            <td>{{ rep.department }}</td>
          </tr>
          <tr *ngIf="reps.length === 0">
            <td colspan="9" class="no-data">MP担当者データがありません</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>
